import type { OrderOut } from '@/types/api';

/** Offline provider only. API mode always displays the status from FastAPI. */
export function advanceMockDemoOrder(order: OrderOut, now = Date.now()): boolean {
  const stages = ['confirmed', 'preparing', 'ready', 'served'];
  const index = stages.indexOf(order.status);
  if (!order.demo_progress_started_at || order.payment_status !== 'paid' || index < 0 || index === 3) return false;
  const elapsed = now - Date.parse(order.demo_progress_started_at);
  const next = elapsed >= 20_000 ? 3 : elapsed >= 11_000 ? 2 : elapsed >= 4_000 ? 1 : 0;
  if (next <= index) return false;
  order.status = stages[next]!;
  order.revision += 1;
  order.updated_at = new Date(now).toISOString();
  return true;
}
